import React, { Fragment, useState, useEffect } from "react";
import Select from "react-select";

export default function MetadataDropDownList(props: any) {
  const [selected, setSelected] = useState({
    name: props?.defaultValue?.label,
    value: props?.defaultValue?.value,
  });
  const [language, setlanguage] = useState(props.languages);
  const saveSelectdData = (e: any) => {
    setSelected(e);
    if (props.dropName === "state") {
      props.dropSelect(e.value);
      props.enableDisableSubjects(false);
    } else if (props.dropName === "subject") {
      props.dropSelect(e.value);
      if (typeof props.enableDisableDomains === "function")
        props.enableDisableDomains(false);
    } else if (props.dropName === "domain") {
      props.dropSelect(e.value);
      props.enableDisableStandards(false);
      if (
        e.value > 0 &&
        (props.questionId === "" || props.questionId === undefined) &&
        window.location.pathname === "/questions/new"
      ) {
        props?.createQuestion(e.value);
      }
    } else if (props.dropName === "standard") {
      props.dropSelect(e.value);
      if (
        e.value > 0 &&
        (props.questionId === "" || props.questionId === undefined) &&
        window.location.pathname === "/questions/new"
      ) {
        props?.createQuestion(e.value);
      }
    } else if (props.dropName === "dok") {
      props.dropSelect(e.value);
    } else if (props.dropName === "stateList") {
      props.dropSelect(e.value);
      props.enableDisableSubjects(false);
    } else if (props.dropName === "subjectList") {
      props.dropSelect(e.value);
      if (typeof props.enableDisableDomains === "function")
        props.enableDisableDomains(false);
    } else if (props.dropName === "domainList") {
      props.dropSelect(e.value);
      props.enableDisableStandards(false);
    } else if (props.dropName === "standardList") {
      props.dropSelect(e.value);
    } else if (props.dropName === "dokList") {
      props.dropSelect(e.value);
    } else {
      props.dropSelect(e.value);
    }
  };

  useEffect(() => {
    setSelected({ name: props.defaultValue, value: props.defaultValue });
    setlanguage(props.languages);
  }, [props.resetDropdown]);

  useEffect(() => {
    setlanguage(props.languages);
  }, [props.languages]);

  useEffect(() => {
    setSelected({ name: props.defaultValue, value: props.defaultValue });
  }, [props.defaultValue]);

  return (
    <Select
      options={props?.dropValue}
      placeholder={selected?.name}
      onChange={(event: any) => saveSelectdData(event)}
      value={selected?.name}
      defaultValue={{ label: selected?.name, value: selected?.value }}
      isSearchable={true}
      isDisabled={props.languages === "ES" ? true : props.disabled}
      theme={(theme) => ({
        ...theme,
        colors: {
          ...theme.colors,
          primary25: "#B3B3B3",
          primary: "#041E42",
        },
      })}
      styles={{
        control: (base, state) => ({
          ...base,
          background:
            document.getElementsByClassName("dark")?.length > 0
              ? "#1A1C23"
              : "white",
          borderColor:
            document.getElementsByClassName("dark")?.length > 0
              ? "#6B7280"
              : "#D1D5DB",
          borderWidth: "1px",
          "&:hover": {
            borderColor:
              state.isFocused &&
              document.getElementsByClassName("dark")?.length > 0
                ? "#6b7280"
                : state.isFocused
                ? "#4c5563"
                : "",
          },
        }),
        singleValue: (base) => ({
          ...base,
          color:
            document.getElementsByClassName("dark")?.length > 0
              ? "white"
              : "#374051",
        }),
        menu: (base) => ({
          ...base,
          color:
            document.getElementsByClassName("dark")?.length > 0
              ? "#262626"
              : "#262626",
          marginTop: 0,
        }),
        input: (base) => ({
          ...base,
          color:
            document.getElementsByClassName("dark")?.length > 0 ? "white" : "",
        }),
      }}
    />
  );
}
